import { render, staticRenderFns } from "./PDFView.vue?vue&type=template&id=e2d372c4"
import script from "./PDFView.vue?vue&type=script&lang=js"
export * from "./PDFView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports